export const FETCHING_MESSAGES = 'FETCHING_MESSAGES';
export const FETCHING_MESSAGES_FINISHED = 'FETCHING_MESSAGES_FINISHED';
export const SET_MESSAGES = 'SET_MESSAGES';
export const SEND_MESSAGE = 'SEND_MESSAGE';